module.exports = {
      id: "comm-spiritual-usage",
      viewBox: "0 0 271.278 58.643",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#comm-spiritual",
      toString: function () {
        return this.url;
      }
    }